import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let inflight = null;

export function useLiveStreams() {
  const [streams, setStreams] = useState(cache || []);
  useEffect(() => {
    if (cache) { setStreams(cache); return; }
    inflight =
      inflight ||
      api("/home")
        .then((h) => (cache = (h.live || []).filter((s) => s.status === "live")))
        .catch(() => (cache = []));
    inflight.then((s) => setStreams(s || []));
  }, []);
  return streams || [];
}

export const sellerLiveStream = (streams, { id, name } = {}) =>
  (streams || []).find(
    (s) =>
      (id && (s.supplier_id === id || s.seller_id === id || s.store_id === id)) ||
      (name && (s.supplier_name || s.host_name) === name)
  ) || null;
